// extracted by mini-css-extract-plugin
module.exports = {"itemContainer":"dashboardItem_itemContainer__jioQ2","arrowIcon":"dashboardItem_arrowIcon__nDQQt","row":"dashboardItem_row__zGa7B"};